import type { PropsWithChildren } from 'react';
import { NavLink } from 'react-router-dom';

export function Shell({ children }: PropsWithChildren) {
  return <div className="app-shell">
    <header className="site-header">
      <NavLink to="/" className="brand" aria-label="Fredrick home">
        <span className="brand-mark">F</span>
        <span><strong>Fredrick</strong><small>Local market repository</small></span>
      </NavLink>
      <nav aria-label="Primary navigation">
        <NavLink to="/import">Import</NavLink>
        <NavLink to="/library">Library</NavLink>
        <NavLink to="/r2-test">R2 test</NavLink>
      </nav>
    </header>
    <main>{children}</main>
    <footer><span>Fredrick reads Owl screenshots locally.</span><span>MapleStory assets and names belong to their respective owners.</span></footer>
  </div>;
}
